module.exports = __webpack_public_path__ + "media/misc/my_profile_icon-d7262e1d.svg";